import { useState, useEffect } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTouchDevice: boolean;
  isDesktop: boolean;
  viewportWidth: number;
  viewportHeight: number;
}

function getDeviceInfo(): DeviceInfo {
  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isTouchDevice: false,
      isDesktop: true,
      viewportWidth: 1024,
      viewportHeight: 768,
    };
  }

  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const isTouchDevice =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches;

  return {
    isMobile,
    isTouchDevice,
    isDesktop: !isMobile,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
  };
}

export function useDevice(): DeviceInfo {
  const [device, setDevice] = useState<DeviceInfo>(getDeviceInfo);

  useEffect(() => {
    const handleChange = () => setDevice(getDeviceInfo());

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    mediaQuery.addEventListener('change', handleChange);
    window.addEventListener('resize', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      window.removeEventListener('resize', handleChange);
    };
  }, []);

  return device;
}
